var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('vue-snotify'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }